export enum Role {
  NO_ROLE = 'NO_ROLE',
  REVISOR = 'REVISOR',
  INFORMATIVE = 'INFORMATIVE',
  OFFICIAL = 'OFFICIAL',
  RESPONSIBLE = 'RESPONSIBLE',
  ADMIN = 'ADMIN',
}
